import ScopeConstants from "constants/ScopeConstants"
import { ScopeShape } from "@gman/gman-redux"
import PropTypes from "prop-types"

export const ReportChargeRatesScope  = {
    key: ScopeConstants.REPORT_CHARGE_RATES,
    selector: (state) => state.reportChargeRates,
    tokenSelector: (state) => state.authentication.token
}

ReportChargeRatesScope.propTypes = PropTypes.shape(ScopeShape).isRequired